import React, {useEffect, useMemo, useState} from 'react';
import {VStack} from "native-base";
import {Tooltip} from "antd";
import {t} from "../../../../../../services/i18n";
import FormInput from "../../../../../common/FormInput";
import {useSelector} from "react-redux";
import CustomCheckbox from "../../../../../common/CustomCheckbox";
import AdvanceSelect from "../../../../../common/AdvanceSelect";
import usePermissions from "../../../../../../services/Permissions";
import {SCHEDULE_CANCEL_REASON_SELECT} from "../../../../../../services/ConstHelper";
import {checkBoxHasDoctorJournal} from "../../../../../../services/Helpers";
import {GlobalConsts} from "../../../../../../styles/GlobalConsts";
import InfoTooltip from "../../../../../common/InfoTooltip";
import HStack from "../../../../../common/Layout/HStack";

const HugimCancellation = (props) => {
    const { defaultValues, onFieldChange, isSingle, isHug, displayComment, hideReason, isAppointment, debtInfo } = props;
    const doctor_journal_settings = useSelector(state => state.box?.box?.settings?.doctor_journal_settings);
    const boxCancelReasonOptions = useSelector(state => state.box.box?.boxCancelReasons?.filter(reason => reason.active));
    const scheduleCancelReasons = useSelector(state => state.box.box?.scheduleCancelReasons?.filter(reason => reason.active));
    const reasonSubmitAttempted = useSelector(state => state.schedule?.confirmationRes?.reasonSubmitAttempted);

    const [reasonId, setReasonId] = useState(defaultValues?.reasonId ?? null);
    const [comment, setComment] = useState(null);
    const [notify, setNotify] = useState(defaultValues?.notify ?? false);
    const [zeroDebt, setZeroDebt] = useState(false);
    const {has} = usePermissions()

    const reasonOptions = useMemo(() => ((isHug ? boxCancelReasonOptions : scheduleCancelReasons) ?? []).map(reason => ({ ...reason, label: reason.name, value: reason.id })), [boxCancelReasonOptions, scheduleCancelReasons, isHug])
    const isRequiredReason = useMemo(() => isAppointment && checkBoxHasDoctorJournal({has}), [doctor_journal_settings]);
    const showZeroDebt = isAppointment && has('cancelAppointmentZeroDebt') && !!debtInfo;

    useEffect(() => {
        onFieldChange({reasonId, comment, notify, ...(showZeroDebt ? { zeroDebt } : {})})
    }, [reasonId, comment, notify, zeroDebt, showZeroDebt]);

    return (
        <VStack width={'100%'} mt={'1rem'}>
            {!hideReason &&
            <FormInput required={isRequiredReason} label={t(`${isHug ? 'hug' : 'session'}CancellationReasonLabel`)} width={'100%'} infoTooltip={t(`${isHug ? 'hug' : 'session'}CancellationReasonTooltip`)}>
                <AdvanceSelect type={SCHEDULE_CANCEL_REASON_SELECT}
                               placeholder={t('select')}
                               initValue={reasonId}
                               options={reasonOptions}
                               onChange={(res) => setReasonId(res?.id ?? null)}
                               isClearable={true}
                               isError={isRequiredReason && !reasonId && reasonSubmitAttempted}
                />
            </FormInput>}
            {displayComment && <FormInput value={comment} onChangeCallback={setComment} label={t('commentOptional')} rows={4} inputType={'multiline'} width={'100%'}/>}
            <VStack space={'0.3rem'}>
                <CustomCheckbox text={
                    <HStack alignItems={'center'}>
                        {t(`cancel-send-notifications${isSingle ? '-signle' : ''}`)}
                        {has('appointmentAutoMessages') && isAppointment && <InfoTooltip title={t('cancel-send-notifications-tooltip')}/>}
                    </HStack>} isChecked={notify} onChange={(val) => setNotify(val)} />
            {showZeroDebt &&
                <Tooltip title={!debtInfo?.canZeroDebt ? t(`zeroDebtDisabled-${debtInfo?.reason}`) : null} placement={GlobalConsts.menu.placement.TOP}>
                    <span style={{width: 'fit-content'}}>
                        <CustomCheckbox text={t(`removeAppointmentDebt${isSingle ? '-single' : '-series'}`)} isChecked={zeroDebt} disabled={!debtInfo.canZeroDebt} onChange={(val) => setZeroDebt(val)} />
                    </span>
                </Tooltip>}
            </VStack>
        </VStack>
    );
};

export default HugimCancellation;